import { Contrat, Bien, Locataire, ContratInfo } from "../../model/Model";
import { del, get, post, put } from "../api";

export async function getContrats(): Promise<ContratInfo[]> {
    try {
        const response = await get('/v1/contrats');
        return response.data?.data || [];
    } catch (error) {
        console.error('Erreur lors de la récupération des contrats:', error);
        return [];
    }
}

export async function supprimerContrat(contratId: number): Promise<void> {
    try {
        await del(`/v1/contrats/${contratId}`);  
    } catch (error) {
        console.error('Erreur lors de la suppression du contrat:', error);
        throw error;
    }   
}


export async function ajouterContrat(contrat: Contrat): Promise<Contrat> {
    try {
        const response = await post('/v1/contrats', contrat);
        
        return response.data?.data || {};
    } catch (error) {
        console.error('Erreur lors de l\'ajout du contrat:', error);
        throw error;
    }
}


export async function getBiensDisponibles(): Promise<Bien[]> {
    try {
        const response = await get('/v1/biens');
        return response.data?.data || [];
    } catch (error) {
        console.error('Erreur lors de la récupération des biens disponibles:', error);
        return [];
    }
}

export async function getLocatairesDisponibles(): Promise<Locataire[]> {
    try {
        const response = await get('/v1/locataires');
        return response.data?.data || [];
    } catch (error) {
        console.error('Erreur lors de la récupération des locataires disponibles:', error);
        return [];
    }
}

export async function getContratById(id: number): Promise<Contrat | null> {
    try {
        const response = await get(`/v1/contrats/${id}`);
        return response.data?.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération du contrat avec l'id ${id}:`, error);
        return null;
    }
}

export async function modifierContrat(contrat: Contrat): Promise<Contrat> {
    try {
        const response = await put('/v1/contrats', contrat);
        return response.data?.data;
    } catch (error) {
        console.error('Erreur lors de la modification du contrat:', error);
        throw error;
    }
}

/**
 * Télécharge le PDF d'un contrat
 */
export async function telechargerContratPdf(contratId: number): Promise<void> {
    try {
        const response = await get(`/v1/contrats/${contratId}/pdf`, { 
            responseType: 'blob' 
        });

        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `contrat_${contratId}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    } catch (error) {
        console.error('Erreur lors du téléchargement du PDF:', error);
        throw error;
    }
}